module.exports = __webpack_public_path__ + "static/media/elizabeth.703052ba.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/elizabeth.jpeg
// module id = 276
// module chunks = 0